import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { AssetType } from '../../../../api/api-reference';

@Component({
  selector: 'app-asset-type-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './asset-type-badge.component.html',
  styleUrls: ['./asset-type-badge.component.scss']
})
export class AssetTypeBadgeComponent {
  @Input() assetType: AssetType | string | null | undefined;

  // What to show instead of the asset type itself, e.g. the utility's name for it.
  @Input() label: string | null | undefined;

  private readonly assetTypeClassMap: Record<AssetType, string> = {
    [AssetType.Customer]: 'asset-type-customer',
    [AssetType.Feeder]: 'asset-type-feeder',
    [AssetType.Incomer]: 'asset-type-incomer',
    [AssetType.DistributionTransformer]: 'asset-type-distribution-transformer',
  };

  get assetTypeClass(): string {
    return this.assetType
      ? this.assetTypeClassMap[this.assetType as AssetType] ?? 'asset-type-default'
      : 'asset-type-default';
  }
}
